import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import gql from 'graphql-tag';
import {Service} from '../models/service';

@Injectable()
export class FileService {

  constructor(private apollo: Apollo) {
  }

  createFile(file) {
  return this.apollo.mutate({
    mutation: gql`
      mutation createFile(
        $path: String!
        $mimetype: String!
        $serviceId: ID
        $attractionId: ID
        $guideId: ID
        $locationId: ID
        $reviewId: ID
        $organizationId: ID
        $filename: String
        $caption: String
        $editor: String
        $credit: String
        $owned: Boolean
        $licensed: Boolean
        $licensedBy: String
        $sublicenseable: Boolean
      ) {
        createFile(
          file: {
            path: $path
            mimetype: $mimetype
            serviceId: $serviceId
            attractionId: $attractionId
            guideId: $guideId
            locationId: $locationId
            reviewId: $reviewId
            organizationId: $organizationId
            filename: $filename
            caption: $caption
            editor: $editor
            credit: $credit
            owned: $owned
            licensed: $licensed
            licensedBy: $licensedBy
            sublicenseable: $sublicenseable
          }
        ) {
          id
          url
          path
          mimetype
          caption
          editor
          credit
          filename
        }
      }
    `,
    variables: {
      path: file.path,
      mimetype: file.mimetype,
      serviceId: file.serviceId,
      attractionId: file.attractionId,
      guideId: file.guideId,
      locationId: file.locationId,
      reviewId: file.reviewId,
      organizationId: file.organizationId,
      filename: file.filename,
      caption: file.caption,
      editor: file.editor,
      credit: file.credit,
      owned: file.owned,
      licensed: file.licensed,
      licensedBy: file.licensedBy,
      sublicenseable: file.sublicenseable
    }
  });
}


  updateFile(file) {
  return this.apollo.mutate({
    mutation: gql`
      mutation updateFile(
        $id: ID
        $path: String!
        $mimetype: String!
        $caption: String
        $editor: String
        $credit: String
        $owned: Boolean
        $licensed: Boolean
        $licensedBy: String
        $sublicenseable: Boolean
      ) {
        updateFile(
          file: {
            id: $id
            path: $path
            mimetype: $mimetype
            caption: $caption
            editor: $editor
            credit: $credit
            owned: $owned
            licensed: $licensed
            licensedBy: $licensedBy
            sublicenseable: $sublicenseable
          }
        ) {
          success
        }
      }
    `,
    variables: {
      id: file.id,
      path: file.path,
      mimetype: file.mimetype,
      credit: file.credit,
      caption: file.caption,
      editor: file.editor,
      owned: file.owned,
      licensed: file.licensed,
      licensedBy: file.licensedBy,
      sublicenseable: file.sublicenseable
    }
  });
}


  delete(file) {
    return this.apollo.mutate({
      mutation: gql`
          mutation removeFile {
            removeFile(file: {id: "${file.id}"}) {
              success
            }
          }
        `
    });
  }

  addToMeetTheLocal(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation addToMeetTheLocal($imageId: ID!, $${idLabel}: ID) {
          addToMeetTheLocal (data: {imageId: $imageId, ${idLabel}: $${idLabel}}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        [data.idLabel]:  data[data.idLabel]
      }
    });
  }

  removeFromMeetTheLocal(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation removeFromMeetTheLocal($imageId: ID!, $${idLabel}: ID) {
          removeFromMeetTheLocal (data: {imageId: $imageId, ${idLabel}: $${idLabel}}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        [data.idLabel]:  data[data.idLabel]
      }
    });
  }

  setAsFeaturedImage(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation setAsFeaturedImage($imageId: ID!, $${idLabel}: ID) {
          setAsFeaturedImage (data: {imageId: $imageId, ${idLabel}: $${idLabel}}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        [idLabel]:  data[idLabel]
      }
    });
  }

  addToGallery(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation addToFileGallery($imageId: ID!, $${idLabel}: ID) {
          addToFileGallery (data: {imageId: $imageId, ${idLabel}: $${idLabel}}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        [idLabel]:  data[idLabel]
      }
    });
  }

  removeFromGallery(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation removeFromGallery($imageId: ID!, $${idLabel}: ID) {
          removeFromGallery (data: {imageId: $imageId, ${idLabel}: $${idLabel}}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        [idLabel]:  data[idLabel]
      }
    });
  }

  updatePremiumFlag(data) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updatePremiumFlag($imageId: ID!, $premium: Boolean!) {
          updatePremiumFlag (data: {imageId: $imageId, premium: $premium}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        premium:  data.premium
      }
    });
  }

  updatePrivateFlag(data) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updatePrivateFlag($imageId: ID!, $private: Boolean!) {
          updatePrivateFlag (data: {imageId: $imageId, private: $private}) {
            success
          }
        }`,
      variables: {
        imageId: data.imageId,
        private:  data.private
      }
    });
  }
  updateLegalFlag(data) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateLegalFlag($fileId: ID!, $legal: Boolean!) {
          updateLegalFlag (data: {fileId: $fileId, legal: $legal}) {
            success
          }
        }`,
      variables: {
        fileId: data.fileId,
        legal:  data.legal
      }
    });
  }

  updateGalleryOrder(data) {
    const idLabel = data.idLabel;
    return this.apollo.mutate({
      mutation: gql`
        mutation updateGalleryOrder($${idLabel}: ID!, $files: [GalleryFileType]) {
          updateGalleryOrder (input: {${idLabel}: $${idLabel}, files: $files}) {
            success
          }
        }`,
      variables: {
        [idLabel]:  data[idLabel],
        files: data.files
      }
    });
  }

  updateAllCredit(data) {
    return this.apollo.mutate({
      mutation: gql`
        mutation bulkUpdateCredit($credit: String!, $imageIds: [ID]) {
          bulkUpdateCredit (input: {credit: $credit, imageIds: $imageIds}) {
            success
          }
        }`,
      variables: {
        credit:  data.credit,
        imageIds: data.imageIds
      }
    });
  }


  getWaterMarkedImage(obj?) {
  return this.apollo.watchQuery({
    query: gql`
      {
        photos(id: "${obj.id}") {
          totalCount
          edges {
            node {
              id
              waterMarkUrl(
                markUrl: "${obj.markUrl}",
                w: ${obj.width || 100},
                h: ${obj.height || 100}
              )
            }
          }
        }
      }
    `
  }).valueChanges;
}
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/file.service.ts